import React, { Component } from 'react';

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Table from './table';
import Navbar from '../../components/navBar/navBar';
import NoAccess from '../../components/NoAccess/NoAccess';
import { verifyLogin, apiList } from '../../helpers';
import OnBoardingDialog from './OnBoardingDialog';

import 'react-toastify/dist/ReactToastify.css';
import PageContainer from '../../components/PageContainer/PageContainer';

class CustomerAccounts extends Component {
  constructor() {
    super();
    this.state = {
      loanId: null,
      formOpen: false,
      loanTypes: [],
      permission: {},
      permissionLoaded: false,
    };
  }

  componentDidMount() {
    const { roleMapping, user } = verifyLogin();
    if (user.userRoleId === 1 || user.userRoleId === 2) {
      this.setState({
        permission: {
          view: true, add: true, edit: true, delete: true,
        },
      });
    } else {
      const permission = roleMapping.find((obj) => obj.PermissionConfig?.name === 'Loan');
      if (permission) {
        this.setState({ permission: permission || {} });
      }
    }
    this.setState({ permissionLoaded: true });
    this.getLoanTypes();
  }

  getLoanTypes() {
    const { session } = verifyLogin();
    const config = { headers: { session } };

    axios.get(`${apiList.VIEW_USERS_LOAN_TYPE_API}`, config)
      .then((response) => {
        this.setState({ loanTypes: [...response.data.data.paginate] });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  deleteLoan(id) {
    if (confirm('CONFIRM TO PROCCESSED )): Your data will lost, if you press OK')) {
      const { session } = verifyLogin();
      const config = { headers: { session, permissionConfig: 'Loan', feature: 'delete' } };
      axios.post(`${apiList.DELETE_LOAN}`, { id }, config)
        .then((response) => {
          toast.success(response.data.message);
          this.loanTable.getLoans();
        })
        .catch((error) => {
          toast.error(`${error.response.data.error || error.response.data.message}`);
        });
    }
  }

  render() {
    const {
      formOpen, loanId, loanTypes, permission, permissionLoaded,
    } = this.state;
    verifyLogin();
    return (
      <div className='ds-page'>
        <ToastContainer />

        <Navbar MainProps={this.props} />

        <PageContainer width='wide'>

          {permission.view
            ? (
              <Table
                permission={permission}
                onAdd={permission.add
                  ? () => this.setState({ formOpen: true, loanId: null })
                  : null}
                ref={(el) => { this.loanTable = el; }}
                MainProps={this.props}
                MainState={this.state}
                handleShowEditForm={(element) => {
                  this.setState({
                    formOpen: true,
                    loanId: element.id,
                  });
                }}
                handleDeleteData={(id) => {
                  this.deleteLoan(id);
                }}
              />
            ) : <NoAccess permissionLoaded={permissionLoaded} what='loans' />}
        </PageContainer>

        {formOpen ? (
          <OnBoardingDialog
            open={formOpen}
            loanTypes={loanTypes}
            handleClose={(reload) => {
              this.setState({ formOpen: false });
              if (reload) {
                this.loanTable.getLoans();
              }
            }}
            loanId={loanId}
          />
        ) : null}

      </div>
    );
  }
}

export default CustomerAccounts;
